/**
 * Nueva versión del aviso de privacidad (T034; FR-007, research R-7).
 *
 * Se muestra en Inicio cuando `GET /me` devuelve `privacy_notice.pending` o cuando cualquier ruta
 * autenticada respondió `428 PRIVACY_NOTICE_REQUIRED` (el cliente encendió el flag de
 * `privacy-store.ts`). Hasta aceptar, el trabajador no continúa: es la misma regla que en la
 * activación, pero con sesión ya establecida (`POST /privacy/accept`).
 */
import { ShieldCheck } from 'lucide-react';

import { Button } from '../../components/ui/button';
import { Screen } from '../../components/ui/screen';
import { t } from '../../i18n';
import { PrivacyNoticeText } from '../activation/privacy-notice';

import { useAcceptPrivacy } from './api';

export interface PrivacyUpdateScreenProps {
  /** Versión vigente según `GET /me`. */
  version: string;
}

export function PrivacyUpdateScreen({ version }: PrivacyUpdateScreenProps) {
  const accept = useAcceptPrivacy();

  return (
    <Screen
      data-testid="privacy-update"
      title={t('access.privacyUpdate.title')}
      lead={t('access.privacyUpdate.lead')}
      footer={
        <>
          {accept.isError ? (
            <p role="alert" className="text-fm-sm text-fm-danger-text">
              {t('access.privacyUpdate.error')}
            </p>
          ) : null}
          <Button
            loading={accept.isPending}
            loadingText={t('common.states.sending')}
            icon={<ShieldCheck aria-hidden="true" size={20} />}
            onClick={() => accept.mutate(version)}
          >
            {t('access.privacyUpdate.action')}
          </Button>
        </>
      }
    >
      <p data-testid="privacy-version" className="text-fm-sm text-fm-text-secondary">
        {t('access.privacyUpdate.version', { version })}
      </p>
      <PrivacyNoticeText />
    </Screen>
  );
}
